import { NonprofitType } from './OverviewPage.types'

export const BEAM_FAQ_PAGE_URL = 'https://www.beamimpact.com/faqs'

export const progressBarData = (nonprofit: NonprofitType) => {
  const { total_donated, target_donation_amount } = nonprofit.impact
  const completionRatio = total_donated / target_donation_amount
  const timesCompleted = Math.floor(completionRatio)
  const percentCompleted =
    (total_donated - timesCompleted * target_donation_amount) / target_donation_amount

  return { completionRatio, timesCompleted, percentCompleted }
}

export const overviewTestIds = {
  blendedRoiMetric: 'blended-roi-metric-container',
  beamRoiMetric: 'beam-roi-metric-container',
  salesLiftRoiMetric: 'sales-lift-metric-container',
  roiDetailsView: 'roi-details-view-container',
  roiCcrLiftBlock: 'roi-ccr-lift-block-container',
}
